import { render } from "./add_appeal.vue?vue&type=template&id=a9637f7e"
import script from "./add_appeal.vue?vue&type=script&lang=js"
export * from "./add_appeal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__